import { UpdateReason } from 'APP/constants/scroll';
import { ITranslateMessageRequest } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { getUserLanguage } from 'UTILS/getUserLanguage';

export async function translateMessage({
  groupId,
  messageId,
}: Omit<ITranslateMessageRequest, 'targetLang'>): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  let message = group.messagesStore.getMessageById(messageId);
  if (!message) {
    return;
  }

  try {
    message.isLoadingTranslate = true;

    const translation = await messageModel.translateMessage({
      groupId,
      messageId,
      targetLang: getUserLanguage(),
    });

    // During translation, the message object may change
    message = group.messagesStore.getMessageById(messageId);
    if (!message) {
      return;
    }

    message.isLoadingTranslate = false;
    if (translation) {
      message.isShowTranslate = true;
      group.messagesStore.addTranslation(translation);
    }

    if (group.isActive) {
      Entities.ChatStore.setScrollChanged(UpdateReason.EditMessage, {
        messageIds: [messageId],
        isAnimated: true,
      });
    }
  } catch (error) {
    message = group.messagesStore.getMessageById(messageId);
    if (message) {
      message.isLoadingTranslate = false;
    }

    console.error(error);
  }
}
